import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

export const useRequestWorkflowVersionStats = (
  workflowId: string,
  version: string,
  dateRange?: { from?: Date; to?: Date },
) => {
  const auth = useAuth();
  const { workspaceId } = useParams();
  const startTime = dateRange?.from?.toISOString();
  const endTime = dateRange?.to?.toISOString();

  return useQuery(
    ["requestCountsForWorkflows", workspaceId, workflowId, version, startTime, endTime],
    () => {
      const url = new URL(
        ENDPOINTS.get_workflow_version_stats(
          Number(workspaceId),
          Number(workflowId),
          Number(version),
        ),
      );
      if (startTime) {
        url.searchParams.set("start_time", startTime);
      }
      if (endTime) {
        url.searchParams.set("end_time", endTime);
      }

      return fetch(url.toString(), {
        headers: authHeader(auth?.userToken ?? ""),
      }).then(handleResponse);
    },
  );
};
